'use strict';

import {mutate} from './promise-fastdom';
import mergeOpts from './merge-opts';
import animate from './animate';
import promiseRAF from './promise-raf';
import easing from 'bezier-easing';

const _ = new WeakMap();

export default function RollingNumber(node, opts) {
    const o = mergeOpts({
        speed: 250,
        delay: 4 / 250, // delay between numbers, relative to speed
        count: 8,
        easing: easing(.7, 0, .3, 1),
        start: ' ',
    }, opts);

    o.node = node;
    o.html = node.innerHTML;
    o.numbers = null;
    o.ready = null;

    _.set(this, o);
}

RollingNumber.prototype.init = function () {
    const o = _.get(this);
    o.ready = Promise.resolve()
        .then(mutate(() => {
            o.node.classList.add('rolling-number');
            const number = o.node.innerHTML.replace('&nbsp;', ' ');
            o.node.innerHTML = number.replace(/(.)/g, function (m) {
                return /\S/.test(m)
                    ? `<span class="rolling-number__item"><span class="rolling-number__inner">${m}</span><span class="rolling-number__placeholder">${m}</span></span>`
                    : m;
            });
        }))
        .then(mutate(() => {
            o.numbers = Array.prototype.map.call(o.node.querySelectorAll('.rolling-number__inner'), inner => {
                const n = parseInt(inner.innerText);
                const count = isNaN(n) ? 2 : o.count + 1;
                if (isNaN(n)) {
                    // handle non-numeric char with simple reveal
                    inner.innerHTML = `<span>${inner.innerText}</span><span></span>`;
                } else {
                    inner.innerHTML = Array(o.count + 1)
                        .fill(0)
                        .map((v, i) => i === o.count ? o.start : (n - i % 10 + 10) % 10)
                        .map(d => `<span>${d}</span>`)
                        .join('');
                }
                inner.style.height = `${100 * count}%`;
                inner.style.gridTemplateRows = `repeat(${count}, 1fr)`;
                return inner;
            });
        }));
    return o.ready;
};

RollingNumber.prototype.ready = function () {
    const o = _.get(this);
    if (!o.ready) {
        o.ready = this.init();
    }
    return o.ready;
};

RollingNumber.prototype.roll = function () {
    const o = _.get(this);
    return this.ready()
        .then(() => Promise.all(o.numbers.map((inner, index) => {
                const count = inner.children.length - 1;
                return Promise.resolve()
                    .then(promiseRAF((o.numbers.length - index - 1) * o.delay * o.speed))
                    .then(() => Array(count).fill(0).reduce((p, v, i) => {
                            return p.then(animate(o.speed, (progress) => {
                                inner.style.transform = `translateY(${(i + progress) / (count + 1) * 100}%)`;
                            }, o.easing));
                        }, Promise.resolve())
                    );
            }))
        )
        .then(() => this.clear())
        ;
};

RollingNumber.prototype.clear = function () {
    const o = _.get(this);
    return this.ready().then(mutate(() => {
        o.node.innerHTML = o.html;
        o.ready = null;
    }));
};